export const messages = {
  en: {
    addMerchantShop: {
      add: 'Add Merchant',
      companyName: 'Company Name',
      requiredCompanyName: 'Required, please enter company name',
      shopType: 'Shop Type',
      selectShopType: 'Please select shop type',
      shopArea: 'Shop Area',
      selectProvince: 'Please select province',
      selectCity: 'Please select city',
      selectDistrict: 'Please select district',
      shopName: 'Shop Name',
      requiredShopName: 'Required, please enter shop name',
      address: 'Address',
      requiredAddress: 'Required, please enter address',
      tel: 'Phone',
      requiredTel: 'Required, please enter phone number',
      tips: 'Default account is phone number; password is phone number, please login to mall system',
      cancel: 'Cancel',
      save: 'Save',
      getAreaFailed: 'Failed to get area information'
    }
  },
  zh: {
    addMerchantShop: {
      add: '添加商家',
      companyName: '公司名称',
      requiredCompanyName: '必填，请填写公司名称',
      shopType: '商铺类型',
      selectShopType: '请选择商铺类型',
      shopArea: '商店地区',
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectDistrict: '请选择区县',
      shopName: '地铺名称',
      requiredShopName: '必填，请填写地铺名称',
      address: '地址',
      requiredAddress: '必填，请填写地址',
      tel: '电话',
      requiredTel: '必填，请填写电话',
      tips: '温馨提示：默认账号为手机号；密码为手机号，请到商城系统登录',
      cancel: '取消',
      save: '保存',
      getAreaFailed: '获取地区信息失败'
    }
  }
}